import React, {FC, ReactNode} from 'react';

import * as styles from './pageLayout.module.scss';


type Props = {
  title: string,
  children?: ReactNode,
};


const PageLayout: FC<Props> = ({title, children: pageContent}) => {
  return (
    <div className={styles.layout}>
      <div className={styles.title}>
        <h1>{title}</h1>
      </div>

      {pageContent}
    </div>
  );
};


export default PageLayout;
